<header>
    <label class="close_button" (click)="close()">x</label>
    <div class="header" style="display:block">
        <h1> {{heading}} </h1>
    </div>
</header>


<div class="body" [style]="errormsg? 'margin: 1% 2% 0% 2%;':  'margin: 1% 2% 2% 2%;'">
    <div class="row">
        <div class="col-6">
            <div>
                <label class="catlabel">Contingency Production Date<span style="color:#ff0000">*</span></label>
                <span class="content">
                    <select class="category" [(ngModel)]="selectedcontprodDateId"
                        (change)="onDropDownChange('contproddate')">
                        <option *ngFor="let contProd of contProdList" [value]="contProd.id">
                            {{contProd.value}}
                        </option>
                    </select>
                </span>

            </div>
        </div>
        <div class="col-6">
            <div>
                <label class="catlabel">Doubleship Date<span style="color:#ff0000">*</span></label>
                <span class="content">
                    <select class="category" [(ngModel)]="selecteddoubleshipDateId">
                        <option *ngFor="let doubleshipDate of doubleshipDateList" [value]="doubleshipDate.id">
                            {{doubleshipDate.value}}
                        </option>
                    </select>
                </span>

            </div>
        </div>



        <div class="col-6">
            <div>
                <label class="catlabel">Plant<span style="color:#ff0000">*</span></label>

                <span class="content">
                    <select class="category" [(ngModel)]="selectedPlantId" (change)="onDropDownChange('plant')">
                        <option *ngFor="let plant of plantList" [value]="plant.id">
                            {{plant.value}}
                        </option>
                    </select>
                </span>

            </div>
        </div>
        <div class="col-6">
            <div>
                <label class="catlabel">Domicile<span style="color:#ff0000">*</span></label>

                <span class="content">
                    <select class="category" [(ngModel)]="selectedDomicileId" (change)="onDropDownChange('domicile')">
                        <option *ngFor="let domicile of domicileList" [value]="domicile.id">
                            {{domicile.value}}
                        </option>
                    </select>
                </span>

            </div>
        </div>
        <div class="col-6">
            <div>
                <label class="catlabel">Route<span style="color:#ff0000">*</span></label>

                <span class="content">
                    <select class="category" [(ngModel)]="selectedRouteId">
                        <option *ngFor="let route of routeList" [value]="route.id">
                            {{route.value}}
                        </option>
                    </select>
                </span>

            </div>
        </div>
        <div class="col-6">
            <div>
                <label class="catlabel">NA Supplier Code</label>
                <span class="content">
                    <input type="text" class="category" [(ngModel)]="selectedNASupplierCode" [maxlength]="5"
                        (keypress)="keyPressAlphaNumeric($event,'nasuppliercode')"
                        oninput="this.value=this.value.slice(0,this.maxLength)">
                </span>

            </div>
        </div>
        <div class="col-6">
            <div>
                <label class="catlabel">Dock</label>

                <span class="content">
                    <select class="category" [(ngModel)]="selectedDockId">
                        <option *ngFor="let dock of dockList" [value]="dock.id">
                            {{dock.value}}
                        </option>
                    </select>
                </span>

            </div>
        </div>

        <div class="col-6">
            <div>
                <label class="catlabel">Volume M3</label>

                <span class="content">
                    <input type="number" min="0" [maxlength]="4" class="category" [(ngModel)]="selectedVolumeM3"
                        (keyup)="keyUpEvent($event,'volumem3')" (blur)="textUpdated('volumem3')">
                </span>

            </div>
        </div>
        <div class="col-6">
            <div>
                <label class="catlabel">Miles Saved</label>

                <span class="content">
                    <input type="number" min="0" class="category" [(ngModel)]="selectedMiles"
                        (keyup)="keyUpEvent($event,'milessaved')" (blur)="textUpdated('milessaved')">
                </span>

            </div>
        </div>
        <div class="col-6">
            <label class="catlabel">LM</label>
            <span class="content">
                <select class="category" [(ngModel)]="lmId">
                    <option *ngFor="let lm of lmList" [value]="lm.id">
                        {{lm.value}}
                    </option>
                </select>
            </span>


        </div>
        <div class="col-6">
            <label class="catlabel">Diagram</label>
            <span class="content">
                <select class="category" [(ngModel)]="diagramId">
                    <option *ngFor="let diagram of diagramList" [value]="diagram.id">
                        {{diagram.value}}
                    </option>
                </select>
            </span>


        </div>
        <div class="col-6">
            <label class="catlabel">Sketch</label>
            <span class="content">
                <select class="category" [(ngModel)]="sketchId">
                    <option *ngFor="let sketch of sketchList" [value]="sketch.id">
                        {{sketch.value}}
                    </option>
                </select>
            </span>


        </div>
        <div class="col-6">
            <div>
                <label class="catlabel">DS Request Needed Y/N</label>

                <span class="content">
                    <select class="category" [(ngModel)]="selectedDSRequestNeededYNId">
                        <option *ngFor="let dSRequestNeededYN of DSRequestNeededYNList" [value]="dSRequestNeededYN.id">
                            {{dSRequestNeededYN.value}}
                        </option>
                    </select>
                </span>

            </div>
        </div>
        <div class="col-6">
            <div>
                <label class="catlabel">DS Without Request Suppliers</label>

                <span class="content">
                    <select class="category" [(ngModel)]="selectedDSWithoutRequestYNId">
                        <option *ngFor="let dSWithoutRequesYN of DSWithoutRequestYNList" [value]="dSWithoutRequesYN.id">
                            {{dSWithoutRequesYN.value}}
                        </option>
                    </select>
                </span>

            </div>
        </div>
        <div class="col-12">
            <div class="row" style="margin:0">
                <div class="col-3 custom_row_left">
                    <label class="catlabel">Evaluation Comment</label>
                </div>
                <div class="col-9 custom_row_right">
                    <input type="text" class="custom_row" [(ngModel)]="selectedEvaluationComment">
                </div>
            </div>

        </div>
        <div class="col-12">
            <div class="row" style="margin:0">
                <div class="col-3 custom_row_left">
                    <label class="catlabel">Comment</label>
                </div>
                <div class="col-9 custom_row_right">
                    <input type="text" class="custom_row" [(ngModel)]="selectedComment">
                </div>
            </div>

        </div>
    </div>
</div>


<label *ngIf="errormsg" class="errormsg"> {{errormsg}} </label>
<div class=" footer">
    <button (click)="onNoClick()" class="cancel"
        style="display: inline; background: transparent;border: none !important;"> CANCEL </button>
    <button mat-raised-button class="submit" style="display: inline;" (click)="saveClick()">SAVE</button>
</div>